function convertData(input: unknown): string | Blob {
  if (input instanceof Date) {
    return input.toISOString();
  }

  if (input instanceof Blob) {
    return input;
  }

  return `${input}`;
}

export function getFormData<T extends object>(request: T): FormData {
  const data = new FormData();

  Object.keys(request).forEach((key) => {
    const value = request[key as keyof typeof request];
    data.append(key, convertData(value));
  });

  return data;
}
